// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Order_order__CHAdN {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
    padding: 16px 0;
}


.Order_orderTab__rGJtD {
    display: flex;
    overflow: auto;
    background: var(--color-neutral-200);
    padding: 0 16px;
    gap: 24px;
}

.Order_align-left__6\\+aS\\+ {  
    text-align: left; 
}  

.Order_orderTab__rGJtD>button {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 16px 0;
    flex-shrink: 0;

}

.Order_orderTab__rGJtD>button.Order_active__bstF8 {
    border-bottom: solid 4px var(--color-primary);
}

.Order_orderTab__rGJtD>button>div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: var(--color-white);
    background: var(--color-neutral-500);
    border-radius: var(--radius-circle);
    -webkit-border-radius: var(--radius-circle);
    -moz-border-radius: var(--radius-circle);
    -ms-border-radius: var(--radius-circle);
    -o-border-radius: var(--radius-circle);
}

.Order_accordion_item_section__YI0xW {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.Order_accordion_item_section__YI0xW>div {
    padding: 10px;
    background: var(--color-white);
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.Order_accordion_item_img__qBm8D {
    width: 100%;
    border: 1px solid var(--color-neutral-800);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    overflow: hidden;
}

.Order_accordion_item_img__qBm8D>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

@media screen and (min-width :768px) {
    .Order_accordion_item_img__qBm8D {
        width: 50%;
    }
}

/* @media screen and (min-width :992px) {
    .accordion_item_img {
        width: 25%;
    }
} */`, "",{"version":3,"sources":["webpack://./src/Styles/Order.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oCAAoC;IACpC,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;;;;GAIG","sourcesContent":[".order {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-top: 24px;\n    padding: 16px 0;\n}\n\n\n.orderTab {\n    display: flex;\n    overflow: auto;\n    background: var(--color-neutral-200);\n    padding: 0 16px;\n    gap: 24px;\n}\n\n.align-left {  \n    text-align: left; \n}  \n\n.orderTab>button {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 16px 0;\n    flex-shrink: 0;\n\n}\n\n.orderTab>button.active {\n    border-bottom: solid 4px var(--color-primary);\n}\n\n.orderTab>button>div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    color: var(--color-white);\n    background: var(--color-neutral-500);\n    border-radius: var(--radius-circle);\n    -webkit-border-radius: var(--radius-circle);\n    -moz-border-radius: var(--radius-circle);\n    -ms-border-radius: var(--radius-circle);\n    -o-border-radius: var(--radius-circle);\n}\n\n.accordion_item_section {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.accordion_item_section>div {\n    padding: 10px;\n    background: var(--color-white);\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.accordion_item_img {\n    width: 100%;\n    border: 1px solid var(--color-neutral-800);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    overflow: hidden;\n}\n\n.accordion_item_img>img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n@media screen and (min-width :768px) {\n    .accordion_item_img {\n        width: 50%;\n    }\n}\n\n/* @media screen and (min-width :992px) {\n    .accordion_item_img {\n        width: 25%;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order": `Order_order__CHAdN`,
	"orderTab": `Order_orderTab__rGJtD`,
	"align-left": `Order_align-left__6+aS+`,
	"active": `Order_active__bstF8`,
	"accordion_item_section": `Order_accordion_item_section__YI0xW`,
	"accordion_item_img": `Order_accordion_item_img__qBm8D`
};
export default ___CSS_LOADER_EXPORT___;
